import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useFetch } from '../../hooks/useFetch';
import { useEffect, useState } from 'react';
import {
  Container,
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Divider,
  Card,
  Paper,
  CardActions,
  CardContent,
} from '@mui/material/';
import format from 'date-fns/format';
import EditIcon from '@mui/icons-material/Edit';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DataGridView from '../../components/DataGridView';
import PageviewIcon from '@mui/icons-material/Pageview';
import PreviewIcon from '@mui/icons-material/Preview';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import DescriptionIcon from '@mui/icons-material/Description';
import clsx from 'clsx';
function ViewEntryStatus({ studentId, sessionId }) {
  const [tableData, setTableData] = useState([]);

  const {
    postData,
    error,
    isPending,
    data: authList,
  } = useFetch('https://pcapi.bi-oss.co.za/studcambridge/entrystatus', 'POST');

  const handleOnCellClick = (e) => {
    // window.open(e.row.fileURL, '_blank')
  };
  useEffect(() => {
    if (sessionId) {
      postData({
        studentId,
        sessionId,
      });
    }
  }, [sessionId]);

  useEffect(
    (tableData) => {
      if (authList) {
        setTableData(authList);
      }
    },
    [authList],
  );

  const columns = [
    {
      field: 'academicYear',
      headerName: 'Year:',
      width: 100,
      editable: true,
      cellClassName: 'super-app-theme--cell',
    },

    { field: 'session', headerName: 'Session:', width: 120, editable: true },
    {
      field: 'qualification',
      headerName: 'Qualification:',
      width: 120,
      editable: true,
    },
    { field: 'paperCode', headerName: 'Code:', width: 120, editable: true },
    {
      field: 'description',
      headerName: 'Paper Description:',
      width: 200,
      editable: true,
    },

    {
      field: 'action2',
      headerName: 'Entry Status:',
      width: 150,
      renderCell: (params) => {
        if (params.row.paid === 0) {
          return (
            <TextField
              id="stundentConf"
              InputProps={{
                readOnly: true,
              }}
              value="Incomplete"
              fullWidth
              sx={{ borderRadius: 1, input: { color: 'error.main' } }}
            />
          );
        }

        if (params.row.paid === 1) {
          return (
            <TextField
              id="stundentConf"
              InputProps={{
                readOnly: true,
              }}
              value="Complete"
              fullWidth
              sx={{ borderRadius: 1, input: { color: 'success.main' } }}
            />
          );
        }
      },
    },

    {
      field: 'venue',
      headerName: 'Writing Location:',
      width: 300,
      editable: true,
    },
  ];
  return (
    <>
      {isPending && (
        <Grid item xs={12}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Typography variant="h6" component="h3" color="primary.main">
              Fetching examination list ...
            </Typography>
          </Box>
        </Grid>
      )}

      {!isPending && !error && tableData && tableData.length > 0 && (
        <Grid item xs={12} minWidth={0}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <DataGridView
              tableData={tableData}
              error={error}
              isPending={isPending}
              getFormattedDate={null}
              columns={columns}
              pageSize={15}
              handleOnCellClick={handleOnCellClick}
              getRowId={(row) => row.id}
              getRowClassName={(params) =>
                params.row.paid === 1 ? 'positive' : 'negative'
              }
            />
          </Box>
        </Grid>
      )}

      {!isPending && !error && tableData && tableData.length === 0 && (
        <Grid item xs={12} minWidth={0}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Typography variant="body2" component="p" color="primary">
              <b>
                There are currently no processed entries for the selected
                session.{' '}
              </b>
            </Typography>
          </Box>
        </Grid>
      )}
    </>
  );
}

export default ViewEntryStatus;
